/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
import cn from "clsx"
import style from "./index.module.scss"
import { useState, useEffect } from "react";
import  CoupeIcon  from "../assets/coupe-state.svg"
import  CoupeGreenIcon  from "../assets/coupe-green-state.svg"

type Props = {
  open: boolean;
  closeFn: any;
  data: any;
  currency: string;
};

export default function GiftModel({ open, closeFn, data, currency = "£" }: Props) {
  const { discount, quota, receiveQty, isFreight } = data || {};
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isFirstAnim, setIsFirstAnim] = useState(false);

  let timeout: any = null;
  const openFirstAnim = () => {
    setIsFirstAnim(true);
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      setIsFirstAnim(false);
    }, 1000);
  };

  const closeHandler = () => {
    setIsOpenModal(false);
    setIsFirstAnim(false);
    closeFn && closeFn();
  };

  useEffect(() => {
    setIsOpenModal(open);
    if (open) {
      openFirstAnim();
    }
  }, [open]);

  return (
    isOpenModal && (
      <div className={style.gift_container}>
        {isFirstAnim && <div className={style.gift_first}></div>}
        {!isFirstAnim && (
          <div className={style.gift_box}>
            <div className={style.gift_title}>Congrats! </div>
            <div className={style.gift_tip}>You&apos;ve gotten rewards</div>
            <div className={style.gift_coupe}>
              {
                  !isFreight ? 
                  <div className={cn(style.coupe_card, style.red_border)}>
                    <span className={cn(style.off, style.red)}>
                      <span>{currency}{discount}</span>{" "}Off
                    </span>
                    <span className={cn(style.over, style.red)}>
                      Over{" "}<span>{currency}{quota}</span>
                    </span>
                    <CoupeIcon className={style.bg} />
                  </div>
                  :
                  <div className={cn(style.coupe_card, style.green_border)}>
                    <span className={cn(style.off, style.green)}>
                      <span>{currency}{discount}</span>{" "}Shipping off
                    </span>
                    <CoupeGreenIcon className={style.bg} />
                  </div>
              }
              
              <div className={style.coupe_num}>
                x<span>{receiveQty || 1}</span>
              </div>
            </div>
            <div className={style.gift_tip}>Invite more friends to earn more rewards now!</div>
            <button className={style.gift_btn} onClick={closeHandler}>
              Keep Inviting
            </button>
          </div>
        )}
      </div>
    )
  );
}
